// 导航状态管理工具

const STORAGE_KEY = "blog_navigation_state";

/**
 * 保存页面状态
 * @param {string} path - 页面路径
 * @param {object} state - 状态对象 { page, scrollY }
 */
export function savePageState(path, state) {
  try {
    const allStates = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
    allStates[path] = {
      ...state,
      timestamp: Date.now(),
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(allStates));
  } catch (error) {
    console.error("Error saving page state:", error);
  }
}

/**
 * 获取页面状态
 * @param {string} path - 页面路径
 * @returns {object|null} 状态对象或 null
 */
export function getPageState(path) {
  try {
    const allStates = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
    const state = allStates[path];

    // 如果状态超过 30 分钟，认为过期
    if (state && Date.now() - state.timestamp < 30 * 60 * 1000) {
      return state;
    }
    return null;
  } catch (error) {
    console.error("Error getting page state:", error);
    return null;
  }
}

/**
 * 清除页面状态
 * @param {string} path - 页面路径（可选，不传则清除所有）
 */
export function clearPageState(path) {
  try {
    if (path) {
      const allStates = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
      delete allStates[path];
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(allStates));
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch (error) {
    console.error("Error clearing page state:", error);
  }
}

/**
 * 保存来源页面信息
 * @param {string} from - 来源路径
 */
export function saveReferrer(from) {
  try {
    sessionStorage.setItem("blog_referrer", from);
  } catch (error) {
    console.error("Error saving referrer:", error);
  }
}

/**
 * 获取来源页面信息
 * @returns {string|null} 来源路径或 null
 */
export function getReferrer() {
  try {
    return sessionStorage.getItem("blog_referrer");
  } catch (error) {
    console.error("Error getting referrer:", error);
    return null;
  }
}

/**
 * 清除来源页面信息
 */
export function clearReferrer() {
  try {
    sessionStorage.removeItem("blog_referrer");
  } catch (error) {
    console.error("Error clearing referrer:", error);
  }
}
